import styled from 'styled-components';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space__xs);

  & + & {
    margin-top: var(--space__md);
  }
`;

export const SectionTitle = styled.h4`
  font-weight: 600;
  font-size: var(--font-size__sm);
  color: var(--fgColor-default);
  margin: 0;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space__lg);
`;

export const ItemsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space__sm);
`;
